import {
    FETCHING_SHOWCASE,
    FETCHING_SHOWCASE_SUCCEEDED,
    FETCHING_SHOWCASE_FAILED,
    UPDATE_VIEWS_REQUEST,
    UPDATE_VIEWS_SUCCEEDED,
    UPDATE_VIEWS_FAILED,
    UPDATE_LIKES_REQUEST,
    UPDATE_LIKES_SUCCEEDED,
    UPDATE_LIKES_FAILED
  } from "constants/actionTypes.jsx";
  
import { createAction } from "redux-actions";
import { actionChannel, call, put, takeLatest } from "redux-saga/effects";
import buildUrl from 'build-url';
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const SEARCH_URL = `${apiUrl}/api/2.0/showcase/search`;
const SHOWCASE_URL = `${apiUrl}/api/2.0/showcase`;
  
/*
* Fetching storyboards
*/
  
export const fetchingShowcase = createAction(FETCHING_SHOWCASE, (request, page, limit = 50) => {
    return {
       page: page,
       limit: limit,
       request: request
    };
});
  
const fetchingShowcaseSuccedded = createAction(FETCHING_SHOWCASE_SUCCEEDED, (response) => {
      return response;
});
  
const fetchingShowcaseFailed = createAction(FETCHING_SHOWCASE_FAILED, (error) => {
      return error;
});

function* fetchingShowcaseSaga(action) {
    const { request, page , limit } = action.payload;
    var params = {
        page: page,
        limit: limit
      }
    
    let url = buildUrl(SEARCH_URL, {
        queryParams: params
    });
    
    const fetchingShowcaseAPI = () => {
        return axios.post(url, request).then(response => response.data);
    };
    
    try {
        const response = yield call(fetchingShowcaseAPI);
        yield put(fetchingShowcaseSuccedded(response));
    } catch (error) {
        yield put(fetchingShowcaseFailed(error));
    }
}
  
/*
* Updating views
*/

export const updateViews = createAction(UPDATE_VIEWS_REQUEST, (id) => {
    return {
      id: id
    };
});
  
const updateViewsSuccedded = createAction(UPDATE_VIEWS_SUCCEEDED,(response) => {
      return response;
});
  
const updateViewsFailed = createAction(UPDATE_VIEWS_FAILED,(error) => {
      return error;
});

function* updateViewsSaga(action) {
    const { id } = action.payload;
    var params = {
      id: id
    }
    let url = buildUrl(SHOWCASE_URL, {
      path: `${id}/views`
    });
    const updateViewsAPI = () => {
      return axios.put(url, params).then(response => response.data);
    };
    try {
      const response = yield call(updateViewsAPI);
      yield put(updateViewsSuccedded(response));
    } catch (error) {
      yield put(updateViewsFailed(error));
    }
}

/*
* Updating likes
*/
  
export const updateLikes = createAction(UPDATE_LIKES_REQUEST, (id) => {
    return {
      id: id
    };
});
  
const updateLikesSuccedded = createAction(UPDATE_LIKES_SUCCEEDED,(response) => {
    return response;
});
  
const updateLikesFailed = createAction(UPDATE_LIKES_FAILED,(error) => {
    return error;
});
  
function* updateLikesSaga(action) {
    const { id } = action.payload;
    var params = {
      id: id
    }
    let url = buildUrl(SHOWCASE_URL, {
      path: `${id}/likes`
    });
    const updateLikesAPI = () => {
      return axios.put(url, params).then(response => response.data);
    };
  
    try {
      const response = yield call(updateLikesAPI);
      yield put(updateLikesSuccedded(response));
    } catch (error) {
      yield put(updateLikesFailed(error));
    }
}
  
export default function* showcaseSaga() {
    yield takeLatest(FETCHING_SHOWCASE, fetchingShowcaseSaga);
    yield takeLatest(UPDATE_VIEWS_REQUEST, updateViewsSaga);
    yield takeLatest(UPDATE_LIKES_REQUEST, updateLikesSaga);
};